import { isEmpty } from 'lodash';
import LineItemDetails from '../../../types/lineItemDetails';
import { FeedbackGroup } from '../../../types/feedback/FeedbackGroup';

/**
 * If present returns the first lineItem present in the group, else the empty LineItemDetails object
 */
export const getFirstLineItemInFeedbackGroup = (
  lineItems: LineItemDetails[],
  feedbackGroup: FeedbackGroup
): LineItemDetails => {
  if (isEmpty(feedbackGroup.lineItemIds) || isEmpty(lineItems))
    return new LineItemDetails();

  const firstLineItemId = feedbackGroup.lineItemIds[0];

  const firstLineItem = lineItems.find(
    lineItem => lineItem.id === firstLineItemId
  );

  return firstLineItem || new LineItemDetails();
};
